import React from "react";
import PropTypes from "prop-types";

import {
  PictureCover,
  PictureImage
} from "../../../../globalStyles/Containers";

export const PictureBox = ({ picture, indexLink }) => {
  const { file_name, file_binary } = picture;
  const key = `link-${file_name}-${indexLink}`;
  return (
    <PictureCover key={key}>
      <PictureImage
        data-testid={`picture-loaded-${key}`}
        status="SENT"
        backgroundSrc={
          file_binary ? `data:image/png;base64,${file_binary}` : file_name
        }
      />
    </PictureCover>
  );
};

PictureBox.propTypes = {
  picture: PropTypes.shape({
    file_name: PropTypes.string,
    isLoading: PropTypes.bool,
    file_binary: PropTypes.string
  }).isRequired,
  indexLink: PropTypes.number.isRequired
};

export default PictureBox;
